import { useEffect } from "react";
import NextLink from "next/link";
import Head from "next/head";
import { useRouter } from "next/compat/router";
import { Heading, Box, Link, IconFa } from "@cruk/cruk-react-components";

import { useSwrGet } from "@fwa/src/hooks/useSwrGet";
import { queryAsString } from "@fwa/src/utils/urlUtils";
import { useBrandContext } from "@fwa/src/contexts/BrandContext";
import { fwsUrSuperTeamPageSlug } from "@fwa/src/services/superTeamService";
import { getBrandForPage } from "@fwa/src/utils/pageUtils";

import { ErrorPageWrapper } from "@fwa/src/components/ErrorPageWrapper";
import { TeamLeaderboardListPaginated } from "@fwa/src/components/LeaderboardListPaginated";

import sharedStyles from "@fwa/src/components/styles.module.css";

import { type BrandNameType, type SuperTeamPageType } from "@fwa/src/types";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";

export const SuperTeamLeaderboardTeamsPage = ({
  memberType,
}: {
  memberType: "page" | "team";
}) => {
  const router = useRouter();
  const { slug } = router?.query || {};
  const slugString = queryAsString(slug);
  const url = slugString.length
    ? fwsUrSuperTeamPageSlug({ slug: slugString })
    : null;
  const { data: superTeam, error } = useSwrGet<SuperTeamPageType>(url);

  const themeName = superTeam
    ? superTeam?.theme || getBrandForPage(superTeam)
    : null;
  const [brandName, setBrandName] = useBrandContext();
  useEffect(() => {
    if (!!themeName && themeName !== brandName) {
      setBrandName(themeName as BrandNameType);
    }
  }, [themeName, brandName, setBrandName]);

  return (
    <ErrorPageWrapper error={error || undefined}>
      {superTeam ? (
        <>
          <Head>
            <title>{`${superTeam.title} leaderboard`}</title>
          </Head>
          <div className={sharedStyles["content-max-width"]}>
            <Box backgroundColor="background-light" padding="s" marginTop="m">
              <NextLink
                href={`/unite${superTeam.url.slice(
                  superTeam.url.lastIndexOf("/"),
                )}`}
                data-cta-type="link-super-team"
              >
                <Link appearance="secondary" as="span">
                  <IconFa faIcon={faCaretLeft} size="s" />
                  Back to team page
                </Link>
              </NextLink>
            </Box>
            <Box backgroundColor="background-light" padding="s" marginTop="m">
              <Heading h1>
                {router?.pathname.includes("leaderboardpages")
                  ? "Fundraiser leaderboard"
                  : "Team Leaderboard"}
              </Heading>
              <Box>
                {/* leaderboard block */}
                <TeamLeaderboardListPaginated
                  page={superTeam}
                  memberType={memberType}
                />
              </Box>
            </Box>
          </div>
        </>
      ) : null}
    </ErrorPageWrapper>
  );
};

export default SuperTeamLeaderboardTeamsPage;
